export default __webpack_public_path__ + "static/preview-5acd1c3828040c7817a8d44dd55dc143.png";